import OdcFormTabs from "./OdcFormTabs";
import { odcDefaultValues } from "./odcDefaultValues";
import Odc from "../Odc";
import { useAddOdc } from "../Hooks/useAddOdc";

export const AddOdc = () => {
  const { mutate: addOdc } = useAddOdc();

  return <OdcFormTabs title="Add ODC" odc={odcDefaultValues} onSave={(odc: Odc) => addOdc(odc)} />;
};
